import { useHMSLeaveRoom } from "../hms";
import { useLivekitLeaveRoom } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderLeaveRoom = () =>
  useProviderHook({
    hms: useHMSLeaveRoom,
    livekit: useLivekitLeaveRoom,
  })();
